import { render, staticRenderFns } from "./ContentSingle.vue?vue&type=template&id=2aee51f0"
import script from "./ContentSingle.vue?vue&type=script&lang=js"
export * from "./ContentSingle.vue?vue&type=script&lang=js"
import style0 from "./ContentSingle.vue?vue&type=style&index=0&id=2aee51f0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports